import axios from "axios";
const baseUrl = "/api/v1";

export const downloadHelper = {
  post: (payload) => axios.post(`${baseUrl}/download/helper`, payload),
};
